import app from './app';

// hindi
export default {
  app,
};
